import { useState, useCallback } from 'react'
import { ICallListParams, ICallListResponse, requestCarrierCallList } from '../api/callList'

interface IUseRequestCallListState {
  requestCallList: (callListParams: ICallListParams) => Promise<ICallListResponse | undefined>
  error: string
  setError: (err: string) => void
  isLoading: boolean
}

export const useRequestCallListApi = (): IUseRequestCallListState => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  const requestCallList = useCallback(async (callListParams: ICallListParams): Promise<
    ICallListResponse | undefined
  > => {
    setLoading(true)
    try {
      const callListResults = await requestCarrierCallList(callListParams)
      setLoading(false)
      setError('')
      return callListResults
    } catch (err) {
      setError(err)
      setLoading(false)
      return undefined
    }
  }, [])

  return {
    requestCallList,
    error,
    setError,
    isLoading,
  }
}
